import { Link } from 'react-router-dom'

const ProjectCard = ({ project }) => {
    return (
        <Link to = {`/projects/${project.id}`} className="project-card">
            <div className="project-card-media">
                <img src = {project.cover} alt = {`${project.name} screenshot`}/>
            </div>
            <div className="project-card-body">
                <h3>{project.name}</h3>
                <p>{project.tagline}</p>
                <ul className="chips">
                    {project.tech.map(item => <li className="chip" key = {item}>{item}</li>)}
                </ul>
            </div>
        </Link>
    )
}

export default ProjectCard;
